<template>
  <div class="dashboard-chart-line">
    <h2 v-html="charttitle"></h2>
    <div class="dashboard-chart-line-container" :style="'height:' + chartheight + ';'">
      <div class="dashboard-chart-line-component" :style="'height:' + chartheight + ';'" :id="chartid"></div>
      <div class="nodatachartinfo" v-if="!chartdata">{{ $t("DashboardProduct.nodata") }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chartheight: String,
    animation: Boolean,
    chartid: String,
    charttitle: String,
    chartdata: {
      type: Object
    }
  },
  created() {
    this.$nextTick(() => {
      this.initLineChart(this.chartdata)
    });
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.initLineChart(this.chartdata)
      });
    }
  },
  methods: {
    initLineChart: function(chartdata){
      let myLineChart = this.$echarts.init(document.getElementById(this.chartid))
      myLineChart.clear()
      myLineChart.setOption({
        legend: {
          top: 0,
          right: 30,
        },
        grid:{
          left: 50,
          top:30,
          bottom:20,
          right:30
        },
        tooltip: {
          trigger: 'axis',
          axisPointer:{
            type: 'line',
            lineStyle: {
              color: '#ccc'
            }
          },
        }, 
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {
            show: false
          },
          data: chartdata.xAxis
        },
        yAxis: {
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#999',
            fontSize: 12,
          }
        },
        series: chartdata.yAxis,
        color:['#F47373', '#7290F2', '#7290F2', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9'],
        animation: this.animation
      })
      $(window).resize(function () {
        myLineChart.resize()
      })

    },

  }
}
</script>
